import { GridColDef } from '@mui/x-data-grid';

/**
 * Creates an array of grid column definitions to be used for a loading state.
 *
 * @param numColumns - The total number of columns to generate.
 * @param displayText - The text to be displayed as the header name for each column.
 * @returns An array of grid column definitions with the specified header name.
 */
export const createLoadingColumns = (
  numColumns: number,
  displayText: string
): GridColDef[] =>
  Array.from({ length: numColumns }, (_, index) => ({
    field: `column-${index}`,
    headerName: displayText,
    type: 'string',
  }));
